'use strict';

exports.__esModule = true;

var _reactRouter = require('react-router');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _reactRouter.Switch;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/Switch.js
// module id = 913
// module chunks = 0